import {graphql, useFragment} from 'react-relay'
import {CreateIssueDialogEntry, type CreateIssueDialogEntryProps} from '@github-ui/issue-create/CreateIssueDialogEntry'
import type {SubIssuesCreateDialog$key} from './__generated__/SubIssuesCreateDialog.graphql'
import {noop} from '@github-ui/noop'

export function SubIssuesCreateDialog({
  issue,
  open,
  setOpen,
  onCreateSuccess,
}: {
  issue: SubIssuesCreateDialog$key
  open: boolean
  setOpen: (open: boolean) => void
  onCreateSuccess: CreateIssueDialogEntryProps['onCreateSuccess']
}) {
  const data = useFragment(
    // !! NOTE: This fragment is preloaded on the server via the primary IssueViewer query, so the data
    // here is loaded whether the flag is enabled or not. Please be careful and don't include fields which
    // are not already loaded by other fragments.
    graphql`
      fragment SubIssuesCreateDialog on Issue {
        id
        repository {
          id
          name
          owner {
            login
          }
        }
      }
    `,
    issue,
  )

  return (
    <CreateIssueDialogEntry
      navigate={noop}
      onCreateSuccess={onCreateSuccess}
      isCreateDialogOpen={open}
      setIsCreateDialogOpen={setOpen}
      optionConfig={{
        scopedRepository: {
          id: data.repository.id,
          owner: data.repository.owner.login,
          name: data.repository.name,
        },
        issueCreateArguments: {
          parentIssue: {
            id: data.id,
          },
        },
      }}
    />
  )
}

try{ SubIssuesCreateDialog.displayName ||= 'SubIssuesCreateDialog' } catch {}